module.exports = __webpack_public_path__ + "img/live22.2692f636.png";